import { render, staticRenderFns } from "./MetadataField.vue?vue&type=template&id=29ae976c&scoped=true&"
import script from "./MetadataField.vue?vue&type=script&lang=js&"
export * from "./MetadataField.vue?vue&type=script&lang=js&"
import style0 from "./MetadataField.vue?vue&type=style&index=0&id=29ae976c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ae976c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VRow})
